// import Image from "next/image";
import s from './solvd.module.css';

export const SolvdHome = () => {
	return (
		<div className={s.container}>
			<div className={s.boxesContainer}>
				<img
					// src={"/images/food.webp"}
					src={
						'https://res.cloudinary.com/dy6bbey4u/image/upload/v1738667029/wft7nyz35lzxmisefpdt.jpg'
					}
					// width={width > 860 ? 500 : width}
					// height={(width > 860 ? 500 : width) * (2128 / 2309)}
					// height={400}
					width={360}
					height={540}
					//   fill
					// sizes="100vw"
					// objectFit="cover"
					style={{ objectFit: 'cover' }}
					className={s.image}
					// layout="responsive"
					alt='Εικόνα φαγητού'
				/>
			</div>
		</div>
	);
};
